import classNames from 'classnames'

import * as styles from './InputWrapLabel.module.css'

function InputWrapLabel({
  className = styles.InputWrapLabel,
  disabled,
  htmlFor,
  label,
}) {
  return (
    <label
      className={classNames(className, { [styles.disabled]: disabled })}
      htmlFor={htmlFor}
    >
      {label}
    </label>
  )
}

export default InputWrapLabel
